<template>
    <div id="asdoria_collection_app">
        <Collection
                :id="collection.id"
                :collection="collection"
        ></Collection>
    </div>
</template>

<script>
    import Collection from "./components/Collection";
    import {hydrateData}  from './store/helper';

    export default {
        name: 'app',
        components: {
            Collection,
        },
        data() {
            return {
                idCollection: null,
                title: '',
                type: '',
                hostname: '',
                collection : {}
            }
        },
        created() {
            hydrateData(this);
        }
    }
</script>

<style>
    #module-asdoria_collections-collection #wrapper {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue